// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CsatSurvey_wrapper__4v4sR","dismiss-button":"CsatSurvey_dismiss-button__vAXAG","prompt":"CsatSurvey_prompt__v3vl9","answers":"CsatSurvey_answers__QEVbD"};